import Vue from 'vue/dist/vue.esm.js'
import axios from 'axios'
import flatPickr from 'vue-flatpickr-component'
import { Japanese } from 'flatpickr/dist/l10n/ja.js'
import 'flatpickr/dist/flatpickr.css'

export class SearchSubsidy {
  constructor() {
    if (document.getElementById('js-subsidy_search') == null) return
    axios.get('/wp-json/wp/v2/custom/subsidy').then(function (res) {
      const vm = new Vue({
        el: '#vue-subsidy-search',
        data: {
          posts: res.data,
          date: vueDate,
          flatOption: {
            locale: Japanese,
            mode: 'range',
            minDate: 'today',
            allowInput: true,
            inline: true,
            nextArrow: '<img src="/img/common/ico/calendar_next.svg">',
            prevArrow: '<img src="/img/common/ico/calendar_prev.svg">',
          },
        },
        components: {
          flatPickr,
        },
        computed: {
          filteredPosts: function () {
            let posts
            if (this.date) {
              let dateSplit = this.date.split(' から ')
              let start = dateSplit[0]
              let end = dateSplit[1]
              posts = this.posts.filter((post) => {
                return post.deadline >= start && post.deadline < end
              })
            } else {
              let today = new Date()
              let year = today.getFullYear()
              let month = today.getMonth() + 1
              let day = today.getDate()
              let formatToday = year + '-' + month.toString().padStart(2, '0') + '-' + day.toString().padStart(2, '0')
              posts = this.posts.filter((post) => {
                return post.deadline >= formatToday
              })
            }
            return posts.length
          },
        },
      })
    })
  }
}
